<script lang="ts">
</script>

<!-- Fixed zone to display alerts -->
<div class="toast toast-end z-100">
  <slot />
</div>
